import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  activateBenefitInstallments: ['isActivate'],
  activateBenefitInstallmentsClear: null,
  activateBenefitInstallmentsSuccess: null,
  activateBenefitInstallmentsRequest: null,
  activateBenefitInstallmentsFailure: ['error']
});

export { Creators, Types };
